import { Navigation } from "components/UIComponents/Navigation";
import { PageTitle } from "components/UIComponents/PageTitle";
import { PrimaryButton } from "components/UIComponents/PrimaryButton";
import { SecondaryButton } from "components/UIComponents/SecondaryButton";
import { Spinner } from "components/UIComponents/Spinner";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { LabelTemplate } from "./LabelDocumentModel";
import { templates } from "./templates";

export interface LabelTemplateListProps {
    onTemplateSelect: (template: LabelTemplate) => void;
    onCancel: () => void;
    loading: boolean;
}

export const LabelTemplateList = (props: LabelTemplateListProps) => {
    const [selectedTemplate, selectTemplate] = useState<LabelTemplate|null>(null);
    const select = () => {
        if (!selectedTemplate) return;
        props.onTemplateSelect(selectedTemplate);
    }
    return <>
        <div className="flex flex-col items-stretch h-screen w-screen">
            <div className="flex-none">
                <Navigation
                    left={
                        <>
                            <PageTitle>
                                <FormattedMessage id="mainpage.label.selectTemplate.title" />
                            </PageTitle>
                        </>
                    }
                    right={
                        <div className="flex items-center gap-4">
                            <PrimaryButton 
                                disabled={!selectedTemplate || props.loading}
                                onClick={select}
                            >
                                <div className="relative">
                                    <span className={`${props.loading&&'opacity-0'}`}>
                                        <FormattedMessage id="management.create"/>
                                    </span>
                                    {props.loading && (
                                        <div className="absolute inset-0 flex justify-center items-center">
                                            <Spinner className="w-4"/>
                                        </div>
                                    )}
                                </div>
                            </PrimaryButton>
                            <SecondaryButton onClick={props.onCancel}>
                                <FormattedMessage id="mainpage.label.selectTemplate.cancel"/>
                            </SecondaryButton>
                        </div>
                    }
                />
            </div>
            <div className="flex-auto flex flex-col overflow-y-auto bg-warm-gray w-full h-full">
                <div className="w-full pt-4 px-12 grid grid-cols-3 gap-12 items-start
                                xl:grid-cols-4 2xl:grid-cols-6">
                    {templates.map((template, i) => (
                        <div className={`w-full rounded-lg overflow-visible
                                bg-white shadow-wine-card cursor-pointer
                                ${selectedTemplate?.id===template.id?'shadow-primary':''}`}
                            onClick={()=>selectTemplate(template)}
                            key={i}
                        >
                            <div>
                                <img src={template.imageUrl} 
                                    alt="glasses" 
                                    className="rounded-t-lg object-cover w-full"
                                />
                            </div>
                            <div className="px-4 py-6 font-fira-sans">
                                <div className="flex items-center">
                                    <h2 className="flex-auto leading-loose text-sm uppercase">
                                        {template.id}
                                    </h2>
                                </div>
                                <p className="text-xs text-light-text leading-loose">
                                    {template.size.width}mm x {template.size.height}mm
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </>
}

